import { useEffect } from 'react';
import { useDexResults } from '../results/use-dex-results';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function useResetDexResultsStoreInitialFrFields() {
    const { dexResultsStore } = useDexResults();
    const { isFirstResponder } = useApplicationType();

    useEffect(() => {
        if (!isFirstResponder) {
            return;
        }

        if (dexResultsStore.frDexPrefillValues) {
            dexResultsStore.setFrPrefillValues(undefined);
        }

        if (dexResultsStore.initialFrDexFormType) {
            dexResultsStore.setInitialFrFormType(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
